import { Translate } from "react-i18nify";
import { useCountDown } from "../helpers/countHelper";

export const LCountDown = ({ from, onDone }: LCountDownProps): JSX.Element => {
    const [counter] = useCountDown({ from, onDone });

    return (
        <h2 className="has-text-dark-blue has-text-centered" style={{ fontSize: "5rem" }}>
            <p>
                <Translate value="assessments.ready" />
            </p>
            {counter}
        </h2>
    );
};

interface LCountDownProps {
    from: number;
    onDone: () => void;
}
